import React, { FC, PropsWithChildren, useMemo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { View, COLOR, TEXT_ROLES } from "@lookiero/aurora";
import { Text } from "@lookiero/sty-psp-ui";
import { style as labelStyle } from "./Label.styles";

interface LabelProps {
  readonly color: COLOR;
  readonly textColor?: COLOR;
  readonly role?: TEXT_ROLES;
  readonly style?: StyleProp<ViewStyle>;
  readonly small?: boolean;
}

const Label: FC<PropsWithChildren<LabelProps>> = ({
  children,
  color,
  textColor,
  style: customStyle,
  role = TEXT_ROLES.p,
  small,
}) => {
  const level = small ? 3 : 2;

  const style = useMemo(() => labelStyle(), []);

  return (
    <View backgroundColor={color} style={[style.wrapper, small ? style.wrapperSmall : undefined, customStyle]}>
      <Text
        color={textColor}
        level={level}
        // @ts-ignore
        role={role}
        variant="detail"
      >
        {children}
      </Text>
    </View>
  );
};

export { Label };
